import { useEffect, useState } from "react";
import { tvFloorLive } from "../../lib/api";
import { BRAINS } from "./AgentBrain";

const TASK = {
  scott: (p, h) => (h ? "Scanned the radar" : `Scanned ${p.rows?.length || 0} · kept ${(p.rows || []).filter((r) => r.kept).length}`),
  jimmy: (p) => `Catalyst check ${p.ticker || ""}`,
  funda: (p) => `Fundamentals ${p.ticker || ""}`,
  prakash: (p) => `Charting ${p.ticker || ""}`,
  crams: (p) => `Validating ${p.ticker || ""}`,
  london: (p) => `Bull case ${p.ticker || ""}`,
  tariq: (p) => `Bear case ${p.ticker || ""}`,
  genie: (p) => `${p.verdict === "APPROVED" ? "Approved" : "Vetoed"} ${p.ticker || ""}`,
};

export function useAgentStatus() {
  const [evs, setEvs] = useState([]);
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    let dead = false;
    const pull = () => tvFloorLive(0, "").then((r) => !dead && setEvs(r.events || [])).catch(() => {});
    pull();
    const t = setInterval(pull, 20000), c = setInterval(() => setNow(Date.now()), 15000);
    return () => { dead = true; clearInterval(t); clearInterval(c); };
  }, []);
  return { evs, now };
}

export const statusOf = (evs, now, orders, hidden) => Object.fromEntries(BRAINS.map((a) => {
  const last = [...evs].reverse().find((e) => e.agent === a);
  let ts = last?.ts ? Date.parse(last.ts) : null;
  let task = last ? TASK[a](last.payload || {}, hidden) : "No work logged";
  const o = a === "genie" && (orders || [])[0];
  if (o?.created_at && (!ts || Date.parse(o.created_at) > ts)) { ts = Date.parse(o.created_at); task = `Order ${o.symbol || ""} ${o.status || ""}`; }
  const age = ts ? (now - ts) / 60000 : null;
  return [a, { task, ts, age, active: age != null && age < 2, inactive: age == null || age > 10 }];
}));

export const ago = (m) => (m == null ? "never" : m < 1 ? "just now" : m < 60 ? `${Math.round(m)}m ago` : m < 1440 ? `${Math.round(m / 60)}h ago` : `${Math.round(m / 1440)}d ago`);
